import '../../../../../node_modules/swiper/core/core.js';
import '../../../../../node_modules/swiper/shared/dom.js';
import Navigation from '../../../../../node_modules/swiper/modules/navigation/navigation.js';
import Pagination from '../../../../../node_modules/swiper/modules/pagination/pagination.js';
import { updateButtons } from '../../../molecules/generic-carousel/utils/updateButtons.js';

function updateOverflowState(swiper, ctx) {
    var _a;
    const snapGridLength = ((_a = swiper.snapGrid) === null || _a === void 0 ? void 0 : _a.length) || 0;
    const totalPages = Math.max(1, snapGridLength || swiper.slides.length || 1);
    const hasOverflow = typeof swiper.isLocked === 'boolean' ? !swiper.isLocked : totalPages > 1;
    if (ctx.hasOverflow !== hasOverflow) {
        ctx.hasOverflow = hasOverflow;
    }
    return { hasOverflow, totalPages };
}
function getBulletsToShow(totalPages, currentIndex) {
    const page = (index) => ({ type: 'page', index });
    const ell = (targetIndex) => ({ type: 'ellipsis', targetIndex });
    if (totalPages <= 5) {
        return Array.from({ length: totalPages }, (_, i) => page(i));
    }
    const first = 0;
    const last = totalPages - 1;
    const items = [];
    const rangeStart = Math.max(first + 1, currentIndex - 1);
    const rangeEnd = Math.min(last - 1, currentIndex + 1);
    items.push(page(first));
    if (rangeStart > first + 2) {
        items.push(ell(rangeStart - 1));
    }
    else if (rangeStart === first + 2) {
        items.push(page(first + 1));
    }
    for (let i = rangeStart; i <= rangeEnd; i++) {
        items.push(page(i));
    }
    if (rangeEnd < last - 2) {
        items.push(ell(rangeEnd + 1));
    }
    else if (rangeEnd === last - 2) {
        items.push(page(last - 1));
    }
    items.push(page(last));
    return items;
}
let _restoreFocusAfterRender = false;
function createEllipsis(targetIndex, swiper) {
    const ellipsis = document.createElement('button');
    ellipsis.className = 'swiper-pagination-ellipsis';
    ellipsis.textContent = '\u2026';
    ellipsis.setAttribute('aria-label', `Go to page ${targetIndex + 1}`);
    ellipsis.onclick = () => {
        _restoreFocusAfterRender = true;
        swiper.slideTo(targetIndex);
    };
    return ellipsis;
}
function createPageBullet(index, currentIndex, swiper) {
    const isActive = index === currentIndex;
    const button = document.createElement('button');
    button.className = `swiper-pagination-bullet ${isActive ? 'swiper-pagination-bullet-active' : ''}`;
    if (isActive) {
        button.setAttribute('aria-current', 'true');
    }
    button.textContent = `${index + 1}`;
    button.onclick = () => {
        _restoreFocusAfterRender = true;
        swiper.slideTo(index);
    };
    return button;
}
function renderCustomPagination(swiper, ctx) {
    const paginationEl = swiper.pagination.el;
    if (!paginationEl)
        return;
    const { hasOverflow, totalPages } = updateOverflowState(swiper, ctx);
    const currentIndex = swiper.activeIndex;
    const shouldRestoreFocus = _restoreFocusAfterRender;
    _restoreFocusAfterRender = false;
    paginationEl.innerHTML = '';
    if (!hasOverflow) {
        return;
    }
    const bulletsToShow = getBulletsToShow(totalPages, currentIndex);
    bulletsToShow.forEach((item) => {
        const element = item.type === 'ellipsis'
            ? createEllipsis(item.targetIndex, swiper)
            : createPageBullet(item.index, currentIndex, swiper);
        paginationEl.appendChild(element);
    });
    if (shouldRestoreFocus) {
        const activeBullet = paginationEl.querySelector('.swiper-pagination-bullet-active');
        activeBullet === null || activeBullet === void 0 ? void 0 : activeBullet.focus();
    }
}
const getProductPreviewPlusSettings = (_props, ctx) => {
    var _a;
    const productPreviewCtx = ctx;
    const nav = (_a = ctx.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('carousel-pagination-navigation');
    const paginationEl = nav === null || nav === void 0 ? void 0 : nav.querySelector('.swiper-pagination-bullets');
    const prevEl = nav === null || nav === void 0 ? void 0 : nav.querySelector('.swiper-button-prev');
    const nextEl = nav === null || nav === void 0 ? void 0 : nav.querySelector('.swiper-button-next');
    const breakpoints = {
        768: { slidesPerView: 2.25, spaceBetween: 24 },
        1024: { slidesPerView: 3.5, spaceBetween: 32 },
        1366: { slidesPerView: 3.5, spaceBetween: 32 },
        1920: {
            slidesPerView: 4,
            spaceBetween: 32,
        },
    };
    return {
        modules: [Navigation, Pagination],
        dir: ctx.rtl ? 'rtl' : 'ltr',
        navigation: {
            nextEl,
            prevEl,
            disabledClass: 'swiper-button-disabled',
        },
        pagination: {
            el: paginationEl,
            type: 'custom',
            renderCustom: () => '',
        },
        on: {
            init: (swiper) => {
                updateOverflowState(swiper, productPreviewCtx);
                updateButtons(swiper);
                renderCustomPagination(swiper, productPreviewCtx);
            },
            toEdge: (swiper) => {
                updateOverflowState(swiper, productPreviewCtx);
                updateButtons(swiper);
            },
            fromEdge: (swiper) => {
                updateOverflowState(swiper, productPreviewCtx);
                updateButtons(swiper);
            },
            slideChange: (swiper) => {
                updateOverflowState(swiper, productPreviewCtx);
                renderCustomPagination(swiper, productPreviewCtx);
            },
            resize: (swiper) => {
                updateOverflowState(swiper, productPreviewCtx);
                renderCustomPagination(swiper, productPreviewCtx);
            },
        },
        a11y: {
            prevSlideMessage: ctx.previousText,
            nextSlideMessage: ctx.nextText,
            paginationBulletMessage: 'Go to slide {{index}}',
        },
        preloadImages: false,
        lazy: true,
        watchOverflow: true,
        slidesPerView: 1.25,
        slidesPerGroup: 1,
        speed: 600,
        spaceBetween: 16,
        breakpoints,
    };
};

export { getProductPreviewPlusSettings };
